/**
 * Add .js class to body tag if JavaScript is enabled
 *
 * @since 1.0.0
 */
document.addEventListener( 'DOMContentLoaded', () => {
	document.body.classList.add( 'js' );
} );

/**
 * Get screen size from getComputedStyle (so we don't have to define each breakpoint twice)
 * -- Values are set in CSS --
 */
function get_screen_size( sizeString ) {
	var size = window.getComputedStyle( document.body, ':after' ).getPropertyValue( 'content' );

	if ( size && size.indexOf( sizeString ) !== -1 ) {
		return true;
	}
}

( function ( $ ) {
	function getScrollPadding( hash ) {
		var padding = -40;
		var adminMobile = 46;
		var adminDesktop = 32;
		var isLoggedIn = $( 'body' ).hasClass( 'admin-bar' );
		var isSticky = $( '.site-container' ).hasClass( 'sticky-header' );
		var mediaQuery = window.matchMedia( '(max-width: 440px)' );
		var postNavigation = document.querySelector( '.rte-post-navigation' );

		// Recipe jump
		if ( hash.indexOf( 'recipe' ) >= 0 ) {
			if ( isLoggedIn ) {
				padding = -40 - adminMobile;
			}

			if ( get_screen_size( 'mobile' ) ) {
				padding = -63;

				if ( isLoggedIn ) {
					padding = -70 - adminMobile;
				}
			}

			if ( get_screen_size( 'tablet' ) ) {
				padding = -70;

				if ( isLoggedIn ) {
					padding = -68 - adminDesktop;
				}
			}

			if ( get_screen_size( 'desktop' ) ) {
				padding = -75;

				if ( isLoggedIn ) {
					padding = padding - adminDesktop;
				}

				if ( isLoggedIn && isSticky ) {
					padding = padding - adminDesktop;
				}
			}

			// Post navigation specific fix
			if ( postNavigation && mediaQuery.matches ) {
				padding = padding - postNavigation.offsetHeight - document.querySelector( '.site-header' ).offsetHeight;
			}
		}

		// Comments Jump
		if ( hash.indexOf( 'comments' ) >= 0 ) {
			padding = -130;

			if ( isLoggedIn ) {
				padding = padding - adminMobile;
			}

			if ( get_screen_size( 'tablet' ) ) {
				if ( isLoggedIn ) {
					padding = padding - adminDesktop;
				}
			}

			if ( get_screen_size( 'desktop' ) ) {
				padding = -135;

				if ( isLoggedIn ) {
					padding = padding - adminDesktop;
				}

				if ( isLoggedIn && isSticky ) {
					padding = padding - adminDesktop;
				}
			}

			// Post navigation specific fix
			if ( postNavigation && mediaQuery.matches ) {
				padding = padding - postNavigation.offsetHeight - document.querySelector( '.site-header' ).offsetHeight;
			}
		}

		// Dozer + Video
		if ( hash.indexOf( 'jump' ) >= 0 ) {
			padding = -140;

			if ( isLoggedIn ) {
				padding = padding - adminMobile;
			}

			if ( get_screen_size( 'tablet' ) ) {
				if ( isLoggedIn ) {
					padding = padding - adminDesktop;
				}
			}

			if ( get_screen_size( 'desktop' ) ) {
				padding = -140;

				if ( isLoggedIn ) {
					padding = padding - adminDesktop;
				}

				if ( isLoggedIn && isSticky ) {
					padding = padding - adminDesktop;
				}
			}

			// Post navigation specific fix
			if ( postNavigation && mediaQuery.matches ) {
				padding = padding - postNavigation.offsetHeight - document.querySelector( '.site-header' ).offsetHeight;
			}
		}

		return padding;
	}

	$( document ).ready( function () {
		const olEls = document.querySelectorAll( 'ol' );

		olEls.forEach( function ( list, index ) {
			if ( list.start > 1 ) {
				const li = list.querySelector( 'li' );

				// Gate so when there is no li in a ol (accidentally), no error
				// could be thrown and break JS on the page.
				if ( li ) {
					li.style.counterReset = 'list-counter ' + parseInt( list.start - 1 );
				}
			}
		} );

		// Mobile Search
		// ==================================================

		// Find only once; unchanging.
		var $transitionLength = 200;
		var $headerHeight = $( '.site-header' ).height() + parseInt( $( '.site-header' ).css( 'border-bottom-width' ) );
		var $searchHeight = $( '#header-search' ).height();
		var $headerWithSearch = $headerHeight + $searchHeight;

		$( '.search-toggle' ).click( function () {
			if ( $( window ).width() < 1024 ) {
				// Find every time the window width changes.
				$adminHeight = $( '#wpadminbar' ).height();

				// Search is being shown.
				if ( $( '#header-search' ).hasClass( 'hidden' ) ) {
					// Update our note-to-self that the search is now visible.
					$( '#header-search' ).removeClass( 'hidden' );

					// Increase mobile nav height to display search bar.
					$( '.site-header' ).animate(
						{
							height: $headerWithSearch,
						},
						$transitionLength
					);

					// Don't forget to consider the navigation.
					$navHeightOffset = $searchHeight;
					$navHeightOffsetWithAdminBar = $headerWithSearch + $adminHeight;
				}

				// Search is being hidden.
				else {
					// Update our note-to-self that the search is now hidden.
					$( '#header-search' ).addClass( 'hidden' );

					// Decrease mobile bar's height to hide search bar.
					$( '.site-header' ).animate(
						{
							height: $headerHeight,
						},
						$transitionLength
					);
					// Don't forget to consider the navigation.
					$navHeightOffset = 0;
					$navHeightOffsetWithAdminBar = $headerHeight + $adminHeight;
				}

				// Either way, let's update the nav.
				$( '.nav-primary' ).animate(
					{
						marginTop: $navHeightOffset,
					},
					$transitionLength
				);
				$( '.nav-primary' ).css( {
					height: 'calc(100% - ' + $navHeightOffsetWithAdminBar + 'px)',
				} );
			}
		} );

		// a11y
		$( '.site-credits-container' ).on( 'focus mouseover', function () {
			$( '.site-credits-container' ).addClass( 'active' );
		} );

		$( '.site-credits-container' ).on( 'blur mouseout', function () {
			$( '.site-credits-container' ).removeClass( 'active' );
		} );

		$( document ).on( 'keyup', function ( event ) {
			if ( event.keyCode == 27 ) {
				$( '.site-credits-container' ).removeClass( 'active' );
			}
		} );

		$( '.maintained a' ).on( 'focus', function () {
			$( '.site-credits-container' ).addClass( 'active' );
		} );

		$( '.maintained a' ).on( 'blur', function () {
			$( '.site-credits-container' ).removeClass( 'active' );
		} );

		// Make social icons focusable
		$( '.dpsp-networks-btns-wrapper button' ).attr( 'tabindex', '0' );

		$( '.dpsp-networks-btns-wrapper a' ).attr( 'tabindex', '0' );

		// Overriding browser's focus styles for Nagi's pick section on Homepage.
		$( '.entry-image-link' ).on( 'focus', function () {
			$( 'img', this ).css( {
				outline: '5px auto Highlight',
				outline: '5px auto -webkit-focus-ring-color',
				'outline-offset': '5px',
			} );
		} );
		$( '.entry-image-link' ).on( 'focusout', function () {
			$( 'img', this ).css( 'outline', 'none' );
		} );
		$( '.social-icon' ).attr( 'tabindex', '0' );

		// Get all youtube embeds in view port
		$( 'span.embed-youtube' ).attr( 'tabindex', '0' );

		$( '.footer-link-heading' ).attr( 'tabindex', '-1' );

		// Adding default form validation
		$( '#commentform' ).removeAttr( 'novalidate' );

		// Custom validity messages
		var comment = document.getElementById( 'comment' );
		var author = document.getElementById( 'author' );
		var email = document.getElementById( 'email' );
		var firstname_sidebar = document.getElementsByClassName( 'firstname-hidden' );
		var email_sidebar = document.getElementsByClassName( 'email-hidden' );
		var firstname_footer = document.getElementById( 'firstname-hidden-footer' );
		var email_footer = document.getElementById( 'email-hidden-footer' );
		createCustomValidation(
			firstname_sidebar,
			'Please enter your first name.',
			'Please enter a valid first name.'
		);
		createCustomValidation(
			email_sidebar,
			'Please enter your email.',
			'Please enter a valid email address. e.g. nagim@recipetineats.com'
		);

		function createCustomValidation( inputElement, message, messageInvalid ) {
			jQuery.each( inputElement, function ( i, theElement ) {
				if ( typeof theElement != 'undefined' && theElement != null ) {
					theElement.addEventListener( 'input', () => {
						theElement.setCustomValidity( '' );
						theElement.checkValidity();
					} );

					theElement.addEventListener( 'invalid', () => {
						if ( theElement.value === '' ) {
							theElement.setCustomValidity( message );
						} else {
							theElement.setCustomValidity( messageInvalid );
						}
					} );
				}
			} );
		}

		if ( typeof comment != 'undefined' && comment != null ) {
			comment.addEventListener( 'input', () => {
				comment.setCustomValidity( '' );
				comment.checkValidity();
			} );

			comment.addEventListener( 'invalid', () => {
				if ( comment.value === '' ) {
					comment.setCustomValidity( 'Comment field is empty.' );
				}
			} );
		}
		if ( typeof author != 'undefined' && author != null ) {
			author.addEventListener( 'input', () => {
				author.setCustomValidity( '' );
				author.checkValidity();
			} );

			author.addEventListener( 'invalid', () => {
				if ( author.value === '' ) {
					author.setCustomValidity( 'Author field is empty.' );
				} else {
					author.setCustomValidity( 'Please enter a valid author name.' );
				}
			} );
		}
		if ( typeof email != 'undefined' && email != null ) {
			email.addEventListener( 'input', () => {
				email.setCustomValidity( '' );
				email.checkValidity();
			} );

			email.addEventListener( 'invalid', () => {
				if ( email.value === '' ) {
					email.setCustomValidity( 'Please enter your email.' );
				} else {
					email.setCustomValidity( 'Please enter a valid email address. e.g. nagim@recipetineats.com' );
				}
			} );
		}

		if ( typeof firstname_footer != 'undefined' && firstname_footer != null ) {
			firstname_footer.addEventListener( 'input', () => {
				firstname_footer.setCustomValidity( '' );
				firstname_footer.checkValidity();
			} );

			firstname_footer.addEventListener( 'invalid', () => {
				if ( firstname_footer.value === '' ) {
					firstname_footer.setCustomValidity( 'Please enter your first name.' );
				} else {
					firstname_footer.setCustomValidity( 'Please enter a valid first name.' );
				}
			} );
		}

		if ( typeof email_footer != 'undefined' && email_footer != null ) {
			email_footer.addEventListener( 'input', () => {
				email_footer.setCustomValidity( '' );
				email_footer.checkValidity();
			} );

			email_footer.addEventListener( 'invalid', () => {
				if ( email_footer.value === '' ) {
					email_footer.setCustomValidity( 'Please enter your email.' );
				} else {
					email_footer.setCustomValidity( 'Please enter a valid email.' );
				}
			} );
		}
		//Adding role to serving slide
		$( '.wprm-recipe-servings-link' ).attr( 'role', 'button' );
		$( '.comment-reply-link' ).attr( 'role', 'button' );
		$( '.comment-reply-link' ).attr( 'aria-pressed', 'false' );

		// Form success
		$( 'form.covertkit-form' ).submit( function ( e ) {
			$( '.form-success-polite', this ).css( 'visibility', 'visible' );
		} );

		// Search form assistive
		$( '.search-form-input' ).attr( 'aria-label', 'Open search panel' );

		// checkbox focus and action label
		var actionText = $( '.facetwp-checkbox' ).clone().children().remove().end().text();
		$( '.facetwp-checkbox' ).attr( {
			'aria-label': 'Tap to filter the results by ' + actionText,
			tabindex: '0',
		} );

		$( '#commentform [required]' ).attr( 'aria-required', 'true' );

		// Unit conversion on recipe page

		$( '.wprm-unit-conversion-container button.wprmpuc-active' ).attr( 'aria-pressed', 'true' );
		$( ".wprm-unit-conversion-container button:not('.wprmpuc-active')" ).attr( 'aria-pressed', 'false' );

		$( '.wprm-unit-conversion-container button' ).on( 'click', function () {
			$( '.wprm-unit-conversion-container .wprmpuc-active' ).attr( 'aria-pressed', 'false' );
			$( ".wprm-unit-conversion-container button:not('.wprmpuc-active')" ).attr( 'aria-pressed', 'true' );
		} );

		// Toggle
		// ==================================================

		$( '.toggle-target' ).toggle(); // Visible by default. Hide if JS enabled.
		$( '.toggle-button' ).click( function () {
			$( this ).next( '.toggle-target' ).slideToggle( 'fast' );
			$( this ).toggleClass( 'activated' );
		} );

		// Scroll to Top
		// ==================================================

		$( '.back-to-top' ).click( function () {
			$( 'html, body' ).animate( {
				scrollTop: 0,
			} );
		} );

		$( '.leave-a-comment' ).click( function () {
			$( 'html, body' ).animate( {
				scrollTop: $( '#respond' ).offset().top,
			} );
		} );

		// Anchor Link Jumping
		// ==================================================

		$( '.wprm-recipe-jump, .jump-button, .entry-meta__comments a' ).click( function () {
			var hash = $( this ).attr( 'href' ).split( '#' )[ 1 ],
				$target = $( '#' + hash ),
				padding = getScrollPadding( hash ); // May tweak based on resolution, browser, or specific element.

			var headerHeight = 60; // Hard-coding this, as the key variance causing bugs is the height of the header being different after scroll than before.

			$( [ document.documentElement, document.body ] ).animate(
				{
					scrollTop: $target.offset().top + ( headerHeight + padding ),
				},
				350
			);
		} );
	} );
	$( '.subscribe-user-icon' ).html(
		'<svg class="svg-inline--fa fa-user fa-w-14" aria-hidden="true" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path></svg>'
	);

	$( '.subscribe-envelope-icon' ).html(
		'<svg class="svg-inline--fa fa-envelope fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path></svg>'
	);

	$( '.fa-instagram' ).replaceWith(
		'<svg class="svg-inline--fa fa-instagram fa-w-14 icon" aria-hidden="true" data-prefix="fab" data-icon="instagram" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>'
	);
	$( '.fa-facebook-f' ).replaceWith(
		'<svg class="svg-inline--fa fa-facebook-f fa-w-9 icon" aria-hidden="true" data-prefix="fab" data-icon="facebook-f" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512" data-fa-i2svg=""><path fill="currentColor" d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"></path></svg>'
	);
	$( '.fa-pinterest-p' ).replaceWith(
		'<svg class="svg-inline--fa fa-pinterest-p fa-w-12 icon" aria-hidden="true" data-prefix="fab" data-icon="pinterest-p" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"></path></svg>'
	);
	$( '.fa-youtube' ).replaceWith(
		'<svg class="svg-inline--fa fa-youtube fa-w-18 icon" aria-hidden="true" data-prefix="fab" data-icon="youtube" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path></svg>'
	);
	$( 'i.fa-chevron-left' ).replaceWith(
		'<svg class="svg-inline--fa fa-chevron-left fa-w-10" aria-hidden="true" data-prefix="fa" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>'
	);
	$( 'i.fa-chevron-right' ).replaceWith(
		'<svg class="svg-inline--fa fa-chevron-right fa-w-10" aria-hidden="true" data-prefix="fa" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>'
	);

	var vimeo_url = $( '[data-vimeo-url]' ).attr( 'data-vimeo-url' );
	jQuery( '[data-vimeo-url]' ).attr( 'src', vimeo_url );
} )( jQuery );
